/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-10 10:21:57
 */
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  ExclamationCircleFilled,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import {
  logoutorEnableExamineAsync,
  selectCurrent,
  setCurrent,
  setTargetId,
  pageExamineAsync,
  examineLogoutEnableListAsync,
  examineExportExcelAsync,
  copyALMUCatalogAsync,
} from './examinetreatSlice'
import { ExamineModal } from './modal'
import { SetMenuModal } from './setMenuModal'
import { AGColumns, Columns } from './columns'
import { DataType } from '../putstorage/putstorage'
import { TableRowSelection } from 'antd/lib/table/interface'
import { ExamineQuery } from './query'
import { examinePageParams } from '../../services/examine'
import {
  Button,
  Col,
  message,
  notification,
  Pagination,
  Row,
  Dropdown,
  Menu,
  Popconfirm,
  Space,
  Spin,
  Modal,
} from 'antd'
import { NavBar } from '../../compnents/nav/NavBar'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import {
  delCodeMedicalListAsync,
  getServerGoodsNo,
  revokeCatalogAsync,
  saveCodeMedicalListAsync,
  updateCatalogAsync,
  searchCategory,
  addCategory,
  deleteCategory,
} from '../commodity/commoditySlice'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantName,
  selectUserName,
  selectUserId,
  selectTenantCategory, selectApiUserType,
} from '../../app/applicationSlice'
import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import { MedicalItem } from '../../models/material'
import { medicalSendHttp, strParse } from '../../utils/MedicalUtils'
import { MedicalModal } from '../commodity/medical/MedicalModal'
import styles from './Examinetreat.module.css'
import { PurchaseModal } from '../putstorelist/purchaseModal'
import { CommodityLastEditModal } from '../commodity/CommodityLastEditModal'
import { CommodityModal } from '../commodity/CommodityModal'
import { CommodityMedicareModal } from '../commodity/CommodityMedicareModal'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../models/dataPersion'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { YJTBJGModal } from '../commodity/YJTBXJDMLSJModal'

export const Examinetreat = (props: {
  isHome?: boolean // 首页消息通知弹框目录更新
}) => {
  // const [size, setSize] = useState(10)

  const dispatch = useDispatch<RootDispatch>()

  const [total, setTotal] = useState(0)

  const [data, setData] = useState([])

  const [info, setInfo] = useState<any>()

  // const Current = useSelector(selectCurrent)

  const [selectIds, setSelectIds] = useState<any>([])

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [isYJTBModalVisible, setIsYJTBModalVisible] = useState(false) //一键同步限价到售价
  const apiUserType = useSelector(selectApiUserType)

  const [queries, setQueries] = useState<any>({
    state: 1,
    current: 0,
    size: 10,
    searchType: 1,
  })

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 62,
      minWidth: 62,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '费用代码',
      field: 'no',
      width: 100,
      minWidth: 100,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
      filter: true,
    },
    {
      headerName: '项目名称',
      field: 'name',
      width: 100,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '匹配状态',
      field: 'approveFlg',
      minWidth: 120,
      visible: true,
    },
    // 非医保不展示 ( 医保国码、医保限价)
    {
      headerName: '医保国码',
      field: 'hilistCode',
      minWidth: 270,
      visible: true,
    },
    {
      headerName: '医保限价',
      field: 'priceLimit',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '零售单价',
      field: 'retailPrice',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '单位',
      field: 'accountUnit',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '排序',
      field: 'sortNo',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '创建时间',
      field: 'createTime',
      align: 'center',
      minWidth: 160,
      sortable: true,
      visible: true,
    },
    {
      headerName: '最近一次修改',
      field: 'lastUpdateTime',
      minWidth: 160,
      sortable: true,
      visible: true,
    },
    {
      headerName: '状态',
      field: 'state',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 200,
      minWidth: 200,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allColumnData = listData

  // 默认要展示的列的值
  const selectColumns = allColumnData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [columnQueryFilterList, setColumnQueryFilterList] = useState<any[]>([])

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [treatmentCategory, setTreatmentCategory] = useState('')

  const [IsModalVisible, setIsModalVisible] = useState(false)

  const [IsMedicareModalVisible, setIsMedicareModalVisible] = useState(false)

  const [batchModalTitle, setbatchModalTitle] = useState<any>()

  const [isBBMLModalVisible, setIsBBMLModalVisible] = useState<any>()

  const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>(
    'checkbox'
  )

  const [medicalModalVisible, setMedicalModalVisible] = useState(false)

  const [componentItem, setComponentItem] = useState<any>()

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [selectRow, setSelectRow] = useState<any>([])

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantCategory = useSelector(selectTenantCategory)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false)

  const [selectCatMappingIds, setSelectCatMappingIds] = useState<number[]>([])

  const [menuModalVisible, setMenuModalVisible] = useState(false) //新增类别弹窗是否显示

  const [categoryList, setCategoryList] = useState<any>() //类别数据

  const [categoryListLoading, setCategoryListLoading] = useState(false) // 类别加载

  const [bgcColor, setBgcColor] = useState<any>(null) // 类别背景颜色控制

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [btnLoading, setBtnLoading] = useState(false) //表格 loading

  const [lastEditVisable, setLastEditVisable] = useState(false)

  const [lastEditId, setLastEditId] = useState<any>()

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'examinertreat',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'examinertreat',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allColumnData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allColumnData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allColumnData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allColumnData)
        setFilterColumnList(allColumnData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (allColumnList?.length) {
      // 非医保不展示 ( 医保国码、匹配状态)
      const columnData = insuranceArray.length ? allColumnList : allColumnList?.filter((v: any) => v.field != 'approveFlg' && v.field != 'hilistCode')
      setColumnQueryFilterList(columnData)
    }
  }, [allColumnList])

  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectIds(selectedRowKeys)
      setSelectRow(selectedRows)
    },
  }

  const [sortedInfo, setSorter] = useState<any>()

  useEffect(() => {
    if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setQueries({
        ...queries,
        createTimeSort: 0,
        lastUpdateTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setQueries({
        ...queries,
        createTimeSort: 1,
        lastUpdateTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'lastUpdateTime'
    ) {
      setQueries({
        ...queries,
        lastUpdateTimeSort: 0,
        createTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'lastUpdateTime'
    ) {
      setQueries({
        ...queries,
        lastUpdateTimeSort: 1,
        createTimeSort: undefined,
      })
    } else if (sortedInfo && sortedInfo?.order == undefined) {
      setQueries({
        ...queries,
        createTimeSort: undefined,
        lastUpdateTimeSort: undefined,
      })
    }
  }, [sortedInfo])

  const medicalMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? updataCatalog('requestString')
            : notificationInfo('请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。')
        }}
      >
        上传勾选目录
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? updataCatalog('requestString', true)
            : notificationInfo('请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。')
        }}
      >
        上传本页全部目录
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? revokeCatalog('requestString')
            : notificationInfo('请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。')
        }}
      >
        撤销勾选目录
      </Menu.Item>
    </Menu>
  )

  const batchAddMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          cycleCode
          setIsBBMLModalVisible(true)
          setbatchModalTitle('标准目录库')
        }}
      >
        标准目录库
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          if (insuranceArray.length) {
            setIsMedicareModalVisible(true)
            setbatchModalTitle('医保目录库')
          } else {
            notification.info({
              message: '未开通医保业务，请联系客服开通',
            })
          }
        }}
      >
        医保目录库
      </Menu.Item>
    </Menu>
  )

  const success = (str: string) => {
    const hide = message.loading(str, 0)
    // Dismiss manually and asynchronously
    setTimeout(hide, 1500)
  }

  const notificationInfo = (str: string) => {
    notification.info({
      message: str,
    })
  }

  const getPageData = () => {
    setPageLoading(true)
    onResize() // 初始化设置高度
    window.addEventListener('resize', onResize)
    dispatch(
      pageExamineAsync({
        ...queries,
        current: queries.current,
        treatmentCategory,
        insuranceCode:
          queries.insuranceCode || insuranceArray[0]?.insuranceCode,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setTotal(res.total)
        setData(res.records)
      })
      .finally(() => setPageLoading(false))
  }

  const useChange = (forceRemove?: number) => {
    if (selectIds.length == 0) {
      notification.info({
        message: '请先选择商品',
      })
    } else {
      dispatch(
        examineLogoutEnableListAsync({
          state: queries.state ? 0 : 1,
          ids: selectIds.join(','),
          forceRemove: forceRemove
        })
      )
        .then(unwrapResult)
        .then(() => {
          setQueries({
            ...queries,
            current: 1,
          })
        })
    }
  }

  // 上传医保数据
  const updataCatalog = async (serverType: any, isAll?: boolean) => {
    const catMappingIds = (isAll ? data : selectRow)
      .map((v: any) => {
        if (v.approveFlg !== '1') {
          if (v.rewriteHilistCode) {
            return "&&&" + v.id
          } else if (v.mappingId) {
            return v.mappingId
          } else {
            return
          }
        } else {
          return
        }

      })
      .filter((v: number) => v)
    const promiseData: any = []
    if (catMappingIds.length) {
      await catMappingIds.forEach((v: number) => {
        // updataCatalogItem(serverType, v)
        promiseData.push(
          new Promise((resolve, reject) => {
            updataCatalogItem(serverType, v, resolve, reject)
          })
        )
      })
      success('上传中')
      Promise.allSettled(promiseData).then((settled: any) => {
        const success: any = settled.filter(
          (v: any) => v.status === 'fulfilled'
        )
        const error: any = settled.filter((v: any) => v.status === 'rejected')
        const msgContent = (
          <div>
            上传完毕，本次共上传{settled.length}条，成功{success.length}条，失败
            {error.length}条，
            {error.length > 0 ? (
              <>
                <Row>详细信息如下：</Row>
                {error.map((v: any, i: number) => {
                  if (!v?.reason?.message) {
                    return <div key={i}>{v?.reason}</div>
                  } else {
                    return (
                      <div
                        key={i}
                        dangerouslySetInnerHTML={{ __html: v?.reason?.message }}
                      ></div>
                    )
                  }
                })}
              </>
            ) : (
              ''
            )}
          </div>
        )
        if (success.length == 0) {
          notification.error({
            message: msgContent,
            duration: 3,
          })
        } else if (success.length == settled.length) {
          notification.success({
            message: msgContent,
            duration: 3,
          })
        } else {
          notification.warn({
            message: msgContent,
            duration: 3,
          })
        }
        getPageData()
        setSelectIds([])
        setSelectRow([])
      })
    } else {
      notificationInfo('请选择已匹配医保代码商品，和未上传商品')
    }
  }

  const updataCatalogItem = (
    serverType: any,
    catMappingId: number,
    resolve: any,
    reject: any
  ) => {
    dispatch(
      updateCatalogAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
          },
          catMappingIds: [catMappingId],
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: string) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data.data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (!err) {
                updataCatalogItem('response', catMappingId, resolve, reject)
              }
            },
            undefined,
            reject
          )
        } else {
          resolve()
        }
      })
      .catch((err) => {
        reject(err)
      })
  }

  // 撤销上传
  const revokeCatalog = async (serverType: any) => {
    const catMappingIds = selectRow
      .map((v: any) => {
        if (v.approveFlg === '1') {
          if (v.rewriteHilistCode) {
            return "&&&" + v.id
          } else if (v.mappingId) {
            return v.mappingId
          } else {
            return
          }
        } else {
          return
        }

      })
      .filter((v: number) => v)
    const promiseData: any = []
    if (catMappingIds.length) {
      await catMappingIds.forEach((v: number) => {
        promiseData.push(
          new Promise((resolve, reject) => {
            revokeCatalogItem(serverType, v, resolve, reject)
          })
        )
      })
      success('撤销中')
      Promise.allSettled(promiseData).then((settled: any) => {
        const success: any = settled.filter(
          (v: any) => v.status === 'fulfilled'
        )
        const error: any = settled.filter((v: any) => v.status === 'rejected')
        const msgContent = (
          <div>
            撤销完毕，本次共撤销{settled.length}条，成功{success.length}条，失败
            {error.length}条，
            {error.length > 0 ? (
              <>
                <Row>详细信息如下：</Row>
                {error.map((v: any, i: number) => {
                  if (!v?.reason?.message) {
                    return <div key={i}>{v?.reason}</div>
                  } else {
                    return (
                      <div
                        key={i}
                        dangerouslySetInnerHTML={{ __html: v?.reason?.message }}
                      ></div>
                    )
                  }
                })}
              </>
            ) : (
              ''
            )}
          </div>
        )
        if (success.length == 0) {
          notification.error({
            message: msgContent,
            duration: 3,
          })
        } else if (success.length == settled.length) {
          notification.success({
            message: msgContent,
            duration: 3,
          })
        } else {
          notification.warn({
            message: msgContent,
            duration: 3,
          })
        }
        getPageData()
        setSelectIds([])
        setSelectRow([])
      })
    } else {
      notificationInfo('请选择已匹配医保代码商品，和已上传商品')
    }
  }

  const revokeCatalogItem = (
    serverType: any,
    catMappingId: number,
    resolve: any,
    reject: any
  ) => {
    dispatch(
      revokeCatalogAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
          },
          catMappingIds: [catMappingId],
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: string) => {
        if (serverType === 'requestString') {
          const data = JSON.parse(res.replace(/\\"/g, '"'))
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data.data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (!err) {
                revokeCatalogItem('response', catMappingId, resolve, reject)
              }
            },
            undefined,
            reject
          )
        } else {
          resolve()
        }
      })
      .catch((err) => {
        reject(err)
      })
  }

  // 匹配医保目录
  const saveMedicalCode = (item: MedicalItem) => {
    dispatch(
      saveCodeMedicalListAsync({
        billing_category: componentItem.billingCategory,
        hilist_code: item?.hiListCode,
        insuranceCode: queries.insuranceCode || insuranceArray[0].insuranceCode,
        is_reimbursement: item?.isCouldBx,
        local_item_id: String(componentItem?.id),
        limitId: item.limitId,
        rid: item?.rid,
        proviceHilistCode: item?.proviceHilistCode,
      })
    )
      .then(unwrapResult)
      .then(() => {
        getPageData()
        notification.success({
          message: '匹配成功',
        })
      })
  }

  // 撤销匹配医保目录
  const delNedicalCode = (item: any) => {
    if (item.approveFlg !== '1') {
      dispatch(
        delCodeMedicalListAsync({
          insuranceCode:
            queries.insuranceCode || insuranceArray[0].insuranceCode,
          mapping_id: String(item?.mappingId),
          localItemId: item?.id,
          medicalType: 2,
        })
      )
        .then(unwrapResult)
        .then(() => {
          getPageData()
          notification.success({
            message: '撤销匹配成功',
          })
        })
    } else {
      notification.info({
        message: '不可删除已上传的匹配记录!',
      })
    }
  }

  useEffect(() => {
    if (insuranceArray.length) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  useEffect(() => {
    if (!queries.current) return
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode == queries.insuranceCode
    )
    if (insuranceItem) {
      setInsuranceItem(insuranceItem)
    }
    getPageData()
    getPageColumnList()
    if (queries) {
      sessionStorage?.setItem('/examinetreat', JSON.stringify(queries))
    }
  }, [queries])

  useEffect(() => {
    return () => {
      setSelectIds([])
    }
  }, [queries.state])

  useEffect(() => {
    //获取类别分类
    setCategoryListLoading(true)
    dispatch(searchCategory())
      .then(unwrapResult)
      .then((res) => {
        setCategoryList([
          {
            name: '全部',
            id: '1234567894562',
          },
          ...res,
        ])
        setCategoryListLoading(false)
      })
      .catch(() => {
        setCategoryListLoading(false)
      })
  }, [menuModalVisible])

  const outExportExcel = () => {
    setBtnLoading(true)
    dispatch(
      examineExportExcelAsync({
        ...queries,
        current: queries.current,
        treatmentCategory,
        checkItemIds: selectIds.join(','),
        insuranceCode:
          queries.insuranceCode || insuranceArray[0]?.insuranceCode,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '诊疗管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .finally(() => setBtnLoading(false))
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
        setQueries({
          ...queries,
          current: 1,
          size: 10,
        })
        setSelectIds([])
        setSelectRow([])
      })
      .catch((res: any) => {
        return
      })
  }

  const onResize = () => {
    const table = document.getElementById('tableHeightExaminetreat')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 10
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {!props.isHome && (
        <Row gutter={10} justify='space-between'>
          <Space>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              className={styles.add}
              onClick={() => {
                setIsModalVisible(true), dispatch(getServerGoodsNo())
              }}
            >
              新增诊疗
            </Button>
            <Dropdown overlay={batchAddMenu} trigger={['click']}>
              <Button
                type='primary'
                icon={<PlusOutlined />}
                className={styles.add}
              >
                批量添加<i className={styles.icon}></i>
              </Button>
            </Dropdown>
            <Dropdown overlay={medicalMenu} trigger={['click']}>
              <Button
                type='primary'
                icon={<PlusOutlined />}
                className={styles.add}
              >
                医保操作<i className={styles.icon}></i>
              </Button>
            </Dropdown>
          </Space>

          <Space>
            {apiUserType !== 'SYLD' &&
                <Button
                    type='primary'
                    onClick={() => {
                      setIsYJTBModalVisible(true)
                    }}
                >
                    一键同步限价到售价
                </Button>
            }

            <Button
              type='primary'
              loading={btnLoading}
              onClick={(() => {
                dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    outExportExcel()
                  })
              })}
            >
              导出
            </Button>
            <Button
              type='primary'
              onClick={() => {
                setIsPurchaseModalVisible(true)
              }}
            >
              导入诊疗目录
            </Button>
            {queries.state ? (
              <Popconfirm
                title={'确认进行注销操作吗？'}
                onConfirm={() => {
                  useChange(1)
                }}
                onCancel={() => {
                  useChange()
                }}
                okText='确认并同步删除套餐/未收费处方'
                //取消按钮当做注销，确认按钮当做强行注销
                cancelButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#027AFF',
                    color: '#FFF',
                  },
                }}
                okButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#fe2121',
                    color: '#FFF',
                  },
                }}
                cancelText='确认'
              >
                <Button type='primary'>{queries.state ? '注销' : '启用'}</Button>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={'确认进行启用操作？'}
                onConfirm={() => {
                  useChange()
                }}
                onCancel={() => {
                  return
                }}
                okText='确认'
                cancelText='取消'
              >
                <Button type='primary'>{queries.state ? '注销' : '启用'}</Button>
              </Popconfirm>
            )}
            {/*<Popconfirm*/}
            {/*  title='确认进行此操作？'*/}
            {/*  onConfirm={() => {*/}
            {/*    useChange()*/}
            {/*  }}*/}
            {/*  okText='确认'*/}
            {/*  cancelText='取消'*/}
            {/*  placement='left'*/}
            {/*>*/}
            {/*  <Button*/}
            {/*    type='primary'*/}
            {/*    // onClick={useChange}*/}
            {/*  >*/}
            {/*    {queries.state ? '注销' : '启用'}*/}
            {/*  </Button>*/}
            {/*</Popconfirm>*/}
          </Space>
        </Row>
      )}
      <div style={{ display: 'flex', height: '100%' }}>
        {!props.isHome && (
          <div className={styles.menuWrap}>
            <Spin spinning={categoryListLoading}>
              <div className={styles.menuTitle}>
                <span>类别</span>
                <span
                  className={styles.menuTitleIcon}
                  onClick={() => setMenuModalVisible(true)}
                >
                  <SettingOutlined />
                </span>
              </div>
              {categoryList &&
                categoryList.map((item: any, index: number) => {
                  return (
                    <div
                      key={item.id}
                      className={styles.menuContent}
                      style={{ background: index == bgcColor ? '#d3dcf3' : '' }}
                      onClick={() => {
                        setBgcColor(index)
                        setQueries({
                          ...queries,
                          current: 1,
                        })
                        item.name == '全部'
                          ? setTreatmentCategory('')
                          : setTreatmentCategory(item.name)
                      }}
                    >
                      {item.name}
                    </div>
                  )
                })}
            </Spin>
          </div>
        )}

        <div
          style={{
            flex: 1,
            width: '50%',
            height: props.isHome ? '100%' : 'calc(100% - 40px)',
            margin: '10px 0',
            padding: '20px 15px',
            background: '#fff',
            borderRadius: '10px',
          }}
        >
          <ExamineQuery
            filterColumn={columnQueryFilterList}
            filterSelectList={filterSelectList}
            submitPageList={((v) => {
              setPageLoading(true)
              submitPageList(v)
              setAllColumnList(v)
            })}
            loading={pageLoading}
            onValueChange={(v) => {
              // setBgcColor(null) //取消类别颜色
              // dispatch(setCurrent(1))
              setQueries({ ...queries, ...v })
            }}
          />
          <div
            id='tableHeightExaminetreat'
            style={{ width: '100%', height: '93%', overflowY: 'hidden' }}
          >
            <SimpleAgGrid
              page={{
                items: data,
                current: queries.current || 1,
                size: queries.size || 10,
                total,
              }}
              column={AGColumns((id, text, item) => {
                if (text === 'edit') {
                  dispatch(setTargetId(id))
                  setInfo({ ...item, ...insuranceItem })
                  setIsModalVisible(true)
                } else if (text === 'loE') {
                  dispatch(logoutorEnableExamineAsync({ id: id })).then(() => {
                    getPageData()
                  })
                } else if (text === 'loEforce') {
                  dispatch(logoutorEnableExamineAsync({ id: id, forceRemove: 1 })).then(() => {
                    getPageData()
                  })
                } else if (text === 'insurance') {
                  if (item.approveFlg !== '1') {
                    setComponentItem(item)
                    setMedicalModalVisible(true)
                  } else {
                    notification.info({
                      message: '不可修改已上传的匹配记录!',
                    })
                  }
                  // medicalSendHttp("")
                } else if (text === 'delCode') {
                  delNedicalCode(item)
                } else if (text === 'copyCatalog') {
                  dispatch(copyALMUCatalogAsync(id))
                    .then(unwrapResult)
                    .then((res: any) => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;复制成功，是否继续编辑新的目录？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          dispatch(setTargetId(res?.id))
                          setInfo({
                            ...res,
                            ...insuranceItem,
                            copyId: res?.id,
                            copyFlag: true,
                          })
                          setIsModalVisible(true)
                        },
                        onCancel: () => {
                          getPageData()
                        },
                      })
                    })
                } else if (text === 'lastEditOperation') {
                  setLastEditVisable(true)
                  setLastEditId(id)
                }
              }, queries.size * (queries.current - 1), columnQueryFilterList)
                ?.filter((item: any) => filterSelectList?.includes(item.field))}
              isLoading={pageLoading}
              pagination={true}
              pageKey={'examinetreat'}
              rowSelection="multiple"
              selectedRowKeys={selectIds}
              getRowId={(data: any) => data?.id?.toString()}
              onRowSelected={((selected, node) => {
                const id = node?.data?.id?.toString()
                const data = node?.data
                if (selected) {
                  // 去重：仅当 id 不存在时才追加
                  if (!selectIds.includes(id)) {
                    setSelectIds([...selectIds, id])
                    setSelectRow([...selectRow, data])
                  }
                } else {
                  setSelectIds(selectIds?.filter((item: any) => item !== id))
                  setSelectRow(selectRow?.filter((item: any) => item.id !== id))
                }
              })}
              suppressRowClickSelection={true}
              // 配置底部行样式
              getRowStyle={(params) => {
                if (params.node.rowPinned) {
                  return {
                    fontWeight: 'normal',
                    backgroundColor: '#D9F2FF',
                  };
                }
                return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
              }}
              onChangePage={(current, size) => {
                setQueries({ ...queries, current, size })
              }}
              onColumnResized={(v: any) => {
                return
              }}
              onColumnMoved={(v) => {
                // dispatch(setPageLoading(true))
                const sortList = getSortColumnList(allColumnList, v);
                submitPageList(sortList)
                setAllColumnList(sortList)
              }}
              onSortChanged={(sortModel, hasComparator) => {
                if (hasComparator) {
                  console.log("sortModel", data, sortModel, hasComparator)
                } else {
                  if (sortModel && sortModel.length > 0) {
                    setSorter(sortModel?.[0])
                  } else {
                    setQueries({
                      ...queries,
                      lastUpdateTimeSort: undefined,
                      createTimeSort: undefined,
                    })
                  }
                }
              }}
              sortedInfo={sortedInfo ? [sortedInfo] : []}
            />
          </div>
          {/* <Pagination
        total={total}
        current={Current}
        pageSize={size}
        showSizeChanger
        showQuickJumper
        showTotal={(total) => `共 ${total} 条`}
        style={{
          position: 'absolute',
          bottom: '40px',
          right: '40px',
        }}
        onChange={(current, size) => {
          setSize(size as number)
          dispatch(setCurrent(current))
        }}
      /> */}
        </div>
      </div>
      <ExamineModal
        info={info}
        categoryList={categoryList}
        visible={IsModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setInfo({})
          getPageData()
        }}
        onOk={() => {
          setIsModalVisible(false)
          setInfo({})
          getPageData()
        }}
      />
      <MedicalModal
        visible={medicalModalVisible}
        onOk={() => {
          setMedicalModalVisible(false)
        }}
        onCancel={() => {
          setMedicalModalVisible(false)
        }}
        onRecord={(item) => {
          setMedicalModalVisible(false)
          saveMedicalCode(item)
        }}
        componentItem={{
          ...componentItem,
          insuranceCode: queries?.insuranceCode,
        }}
        isTreatmentCatalog={true}
      />
      <PurchaseModal
        isPurchaseModalVisible={isPurchaseModalVisible}
        state={3}
        refresh={() => {
          getPageData()
        }}
        onOk={() => {
          setIsPurchaseModalVisible(false)
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
        }}
      />
      <SetMenuModal
        visible={menuModalVisible}
        categoryList={categoryList}
        onCancel={() => {
          setMenuModalVisible(false)
        }}
        onOk={(data) => {
          const params = data.map((item: any, index: any) => {
            return {
              id: item.id,
              name: item.name,
              sortNo: index + 1,
            }
          })
          dispatch(addCategory(params))
            .then(unwrapResult)
            .then((res) => {
              setMenuModalVisible(false)
            })
        }}
        onDelete={(id: number) => {
          // dispatch(deleteCategory({ id })).then(unwrapResult).then(res => {
          //   setMenuModalVisible(false)
          // })
        }}
      />
      <CommodityModal
        visible={isBBMLModalVisible}
        title={batchModalTitle}
        onOk={() => {
          setIsBBMLModalVisible(false)
          getPageData()
        }}
        onCancel={() => {
          setIsBBMLModalVisible(false)
        }}
      />
      <CommodityMedicareModal
        defaultId={'201'}
        visible={IsMedicareModalVisible}
        title={batchModalTitle}
        onOk={() => {
          setIsMedicareModalVisible(false)
          getPageData()
        }}
        onCancel={() => {
          setIsMedicareModalVisible(false)
        }}
      />
      <CommodityLastEditModal
        visible={lastEditVisable}
        title={'最后一次修改'}
        id={lastEditId}
        onOk={() => {
          setLastEditVisable(false)
          setLastEditId('')
        }}
        onCancel={() => {
          setLastEditVisable(false)
          setLastEditId('')
        }}
        operateType={2}
      />
      {/* 一键同步限价到售价 */}
      <YJTBJGModal
        flag={1}  //诊疗管理
        insuranceCode={queries.insuranceCode || insuranceArray[0]?.insuranceCode}
        visible={isYJTBModalVisible}
        onOk={() => {
          setIsYJTBModalVisible(false)
          getPageData()
        }}
        onCancel={() => {
          setIsYJTBModalVisible(false)
        }}
      />
    </div>
  )
}
